<div class="page-wrapper p-3 container-fluid">
  <div class="row mb-3">
    <div class="col-md-12">
      <div class="view-format row border-b">
        <div class="col-md-12">
          <h2 class="row">STUDENT PROFILE</h2>
        </div>

        <ng-container *ngFor="let element of studentProfileArr; let i = index">
          <div class="col-md-3">
            <div class="form-group row">
              <label for="exampleFormControlInput1">{{ element.label }} </label>

              <!-- <span class="view">
                {{ element.value }}
              </span> -->
              <span
                ngxTippy
                class="cursor-pointer"
                [ngxTippy]="profile"
                [tippyProps]="tippyProps"
                [tippyName]="'{{element.value}}' + i"
                >{{ element.value }}</span
              >
              <span #profile>
                <span class="ml-2 pl-3">{{ element.value }}</span>
              </span>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="tog d-flex justify-content-end">
        <div class="view-grid">
          <span
            [ngxTippy]="htmlTemplate"
            [tippyProps]="templateRef"
            class="in active"
            [ngClass]="{ active: isCartView == true }"
            (click)="cardviewView()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
              />
            </svg>
          </span>
          <span
            class="out"
            [ngxTippy]="htmlTemplate1"
            [tippyProps]="templateRef"
            [ngClass]="{ active: isCartView == false }"
            (click)="tableview()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </span>

          <template #htmlTemplate>
            <div class="t-template" #tippyTemplatePassElement>
              <p class="t-template__info text-left">Card View</p>
            </div>
          </template>
          <template #htmlTemplate1>
            <div class="t-template" #tippyTemplatePassElement>
              <p class="t-template__info text-left">Detailed View</p>
            </div>
          </template>
        </div>
        <!-- <label class="switch">
          <input
            [checked]="isCartView"
            type="checkbox"
            (change)="changeView()"
          />
         
          <div class="slider">
            <span class="in">Card View</span>
            <span class="out">Card View</span>
          </div>
        </label> -->
      </div>
    </div>
  </div>

  <div *ngIf="isCartView">
    <app-colleges-cart-view
      [answerMap]="answerMap"
      [universityList]="getCardViewArrayList()"
    ></app-colleges-cart-view>
  </div>
  <div *ngIf="!isCartView">
    <div class="container-fluid bg-white">
      <div class="row">
        <div class="col-12">
          <div class="lr-scroll">
            <span class="arrow">Drag right</span>
            <span class="arrow ml-2">
              <i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i
            ></span>
          </div>
        </div>
      </div>
      <div class="pb-2">
        <!-- *ngIf="isLogin"  -->
        <div class="mb-view">
          <div class="col-md-12 option-pg" id="stickyHeaderAvgTableRow">
            <div class="row">
              <div
                class="col-md-12 choice-brackdown-box list-head mt-2"
                id="stickyHeaderAvg"
              >
                <div class="row">
                  <div class="col">Annual</div>
                  <div
                    class="col text-right"
                    *ngFor="let item of universityList; let index = index"
                  >
                    <div
                      class="top-link"
                      ngxTippy
                      [ngxTippy]="defaultTemplate1"
                      [tippyProps]="tippyProps"
                      [tippyName]="'t6t' + index"
                    >
                      <a
                        *ngIf="searchAutocompleteList.length > 0"
                        class="mr-1 edit-college"
                        (click)="openCollegeNameSearch(index)"
                        ><i
                          class="fa fa-pencil-square-o"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a
                        [ngClass]="
                          checkOutStateGridData(item, index) == true
                            ? 'merit-GridNotUsed'
                            : ''
                        "
                        class="moreview"
                        (click)="OpenUniversitySummaryDialog(item)"
                      >
                        {{ item.dropDownData.name }}</a
                      >

                      <div class="col" #defaultTemplate1>
                        <span class="ml-2 pl-3"
                          >{{ item.dropDownData.name }}

                          <span
                            *ngIf="checkOutStateGridData(item, index) == true"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              class="w-6 h-6"
                              style="
                                display: inline-block;
                                width: 17px;
                                color: rgb(52, 170, 52);
                              "
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                              />
                            </svg>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div
                      class="form-group m-0"
                      *ngIf="isShowAwardLetterDDL[index]"
                    >
                      <select
                        id="exampleFormControlSelect2"
                        (change)="onChangeOcrDataDropDown($event, index)"
                      >
                        <option
                          *ngFor="let opt of setOptionSelectDDl(index)"
                          [value]="opt.value"
                        >
                          {{ opt.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <!-- <div class="row mt-3">
                  <div class="col-md-12">
                <div class="tog d-flex justify-content-end" style="float: left;">
                  <label class="Ipeds-switch">
                    <input
                      [checked]="isIPEDSToggle"
                      type="checkbox"
                      (change)="changeIpeds()"
                    />
                    <div class="Ipeds-slider">
                      <span class="in">IPEDS</span>
                      <span class="out">NPC</span>
                    </div>
                  </label>
                </div>
                </div>
                </div> -->
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="card mb-2 m border-bottom pb-2">
                      <accordion>
                        <accordion-group #myGroup6>
                          <button
                            class="btn btn-link btn-block clearfix"
                            accordion-heading
                            type="button"
                          >
                            <div class="card-header">
                              <div class="row">
                                <div class="col text-left">
                                  <h4 class="m-zero coa">
                                    <i
                                      *ngIf="!myGroup6?.isOpen"
                                      class="fa fa-plus mr-2"
                                    ></i>
                                    <i
                                      *ngIf="myGroup6?.isOpen"
                                      class="fa fa-minus mr-2"
                                    ></i>
                                    {{ costofAttendance }}
                                    <!-- <span> (per year)</span> -->
                                  </h4>
                                </div>
                                <div
                                  class="col text-right"
                                  *ngFor="
                                    let item of universityList;
                                    let index = index
                                  "
                                >
                                  <ng-container *ngIf="!showOcrData[index]">
                                    <span>
                                      {{
                                        getCostOfAttendanceHeaderAmount1(
                                          item,
                                          index
                                        )
                                          ? (getCostOfAttendanceHeaderAmount1(
                                              item,
                                              index
                                            )
                                            | currency
                                              : "$ "
                                              : "symbol"
                                              : "1.0-0")
                                          : "-"
                                      }}
                                      <ng-container
                                        *ngIf="
                                          getErrorInCollegeCost(item, index) ==
                                          true
                                        "
                                      >
                                        <span
                                          class="t-demo__btn unique_span"
                                          ngxTippy
                                          [ngxTippy]="htmlTemplate"
                                          [tippyName]="
                                            't_errorInCollegeCost' + index
                                          "
                                          [tippyProps]="templateRef"
                                          class="text-success ml-1 labeltoolTip-hover"
                                        >
                                          <img
                                            class="cursor-pointer"
                                            src="https://cdn.virtueanalytics.com/cache/exclamation-top5-ic.png"
                                            alt="warning-emoji"
                                          />
                                        </span>
                                        <template #htmlTemplate>
                                          <div
                                            class="t-template"
                                            #tippyTemplatePassElement
                                          >
                                            <p
                                              class="t-template__info text-left"
                                            >
                                              We have identified some
                                              discrepancies in the reported
                                              costs for this college.
                                            </p>
                                          </div>
                                        </template>
                                      </ng-container>
                                    </span>
                                    <!-- <svg *ngIf="getErrorInCollegeCost(item,index)==false" style="color: red" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z" fill="red"></path><path d="M12 14a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1zm-1.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z" fill="red"></path>
                                      </svg> -->
                                  </ng-container>
                                  <ng-container *ngIf="showOcrData[index]">
                                    <span>
                                      {{
                                        item.ocrDataCoaSumEdited
                                          ? (item.ocrDataCoaSumEdited
                                            | currency
                                              : "$ "
                                              : "symbol"
                                              : "1.0-0")
                                          : item.ocrDataCoaSum
                                          ? (roundOfNumber(item.ocrDataCoaSum)
                                            | currency
                                              : "$ "
                                              : "symbol"
                                              : "1.0-0")
                                          : "-"
                                      }}

                                      <!-- {{
                                        item.ocrDataCoaSumEdited
                                          ? (roundOfNumber(
                                              item.ocrDataCoaSumEdited
                                            )
                                            | currency
                                              : "$ "
                                              : "symbol"
                                              : "1.0-0")
                                          : item.ocrDataCoaSum
                                          ? (roundOfNumber(item.ocrDataCoaSum)
                                            | currency
                                              : "$ "
                                              : "symbol"
                                              : "1.0-0")
                                          : "-"
                                      }} -->
                                    </span>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </button>
                          <div class="card-body pt-0 border-bottom pb-3">
                            <accordion>
                              <!-- [closeOthers]="true" -->
                              <accordion-group
                                class="mb-1"
                                [isOpen]="false"
                                #myGroup
                              >
                                <button
                                  class="btn btn-link btn-block clearfix"
                                  accordion-heading
                                  type="button"
                                >
                                  <div class="row">
                                    <div class="col text-left">
                                      <span
                                        [ngClass]="{
                                          'mr-1 minusico': myGroup?.isOpen,
                                          'mr-1 plusico': !myGroup?.isOpen
                                        }"
                                        class="ml-3"
                                      ></span>
                                      Fees breakdown
                                    </div>
                                    <!-- <span
                                      class="col-md-7 text-right"
                                      style="
                                        font-size: 11px;
                                        color: rgb(80, 80, 80);
                                        top: 8px;
                                      "
                                      >*Cost components based on 2021 IPEDS
                                      data</span -->
                                  </div>
                                </button>

                                <app-accordion
                                  [type]="'costOfAttendance'"
                                  [costOfAttendanceData]="costOfAttendanceData"
                                ></app-accordion>
                                <div class="row mt-1">
                                  <div class="col-md-12">
                                    <div
                                      class="tog d-flex justify-content-end"
                                      style="float: left; margin-left: 39px"
                                    >
                                      <span style="font-size: 12px"
                                        >Show IPEDS 2021 Data :</span
                                      >
                                      <label class="Ipeds-switch">
                                        <input
                                          [checked]="isIPEDSToggle"
                                          type="checkbox"
                                          (change)="changeIpeds()"
                                        />
                                        <div class="Ipeds-slider">
                                          <span class="in">On</span>
                                          <span class="out">Off</span>
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <!-- </ng-container> -->
                              </accordion-group>
                              <accordion-group
                                *ngIf="
                                  this.showOcrCoaDataBucket.includes(true) &&
                                  this.showOcrData.includes(true)
                                "
                                class="mb-1"
                                [isOpen]="false"
                                #myGroup5
                              >
                                <button
                                  class="btn btn-link btn-block clearfix"
                                  accordion-heading
                                  type="button"
                                >
                                  <div class="row">
                                    <div class="col text-left">
                                      <span
                                        [ngClass]="{
                                          'mr-1 minusico': myGroup5?.isOpen,
                                          'mr-1 plusico': !myGroup5?.isOpen
                                        }"
                                        class="ml-3"
                                      >
                                      </span>
                                      <span class="position-relative">
                                        COA from Award Letter
                                        <i
                                          class="fa fa-sticky-note-o coa-wd-let-icn"
                                        ></i>
                                      </span>
                                    </div>

                                    <!-- <div class="col text-center" *ngFor="let item of universityList">
                                                                                                               <span *ngIf="item.institutionAidAmountSum>0;else elseSpan">{{ item.institutionAidAmountSum | currency: '$':'symbol':'1.0-0'}}
                                                                                                                  </span>
                                                                                                                  <ng-template #elseSpan>$ 0</ng-template> 
                                                                                                              </div> -->

                                    <div
                                      *ngFor="
                                        let item of universityList;
                                        let index = index
                                      "
                                      class="col text-right"
                                    >
                                      <span
                                        *ngIf="showOcrData[index]"
                                        class="text-sub-total"
                                        [style.color]="getColor(item.color)"
                                      >
                                        <!-- {{
                                          item.hasOwnProperty(
                                            "ocrDataCoaSumEdited"
                                          ) && item?.ocrDataCoaSumEdited
                                            ? "-" -->

                                        <!-- {{
                                          item.ocrDataCoaSumEdited
                                            ? (roundOfNumber(
                                                item.ocrDataCoaSumEdited
                                              )
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : item.hasOwnProperty(
                                                "ocrDataCoaItems"
                                              )
                                            ? (roundOfNumber(item.ocrDataCoaSum)
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : "-"
                                        }} -->

                                        {{
                                          item.ocrDataCoaSumEdited
                                            ? (item.ocrDataCoaSumEdited
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : item.hasOwnProperty(
                                                "ocrDataCoaItems"
                                              )
                                            ? (roundOfNumber(item.ocrDataCoaSum)
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : "-"
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </button>
                                <div
                                  class="row mt-2"
                                  *ngFor="let key of ocrCoaDataList"
                                >
                                  <div class="col">
                                    <Span class="ml-4 pl-3">{{
                                      key.label
                                    }}</Span>
                                  </div>
                                  <div
                                    *ngFor="
                                      let item of universityList;
                                      let index = index
                                    "
                                    class="col text-right"
                                  >
                                    <span
                                      *ngIf="showOcrData[index]"
                                      [style.color]="getColor(item.color)"
                                    >
                                      {{
                                        item.hasOwnProperty(
                                          "ocrDataCoaSumEdited"
                                        ) && item?.ocrDataCoaSumEdited
                                          ? "-"
                                          : item.hasOwnProperty(
                                              "ocrDataCoaItems"
                                            ) &&
                                            item.ocrDataCoaItems.hasOwnProperty(
                                              key.value
                                            ) &&
                                            item.ocrDataCoaItems[key.value] !=
                                              " "
                                          ? (item.ocrDataCoaItems[key.value]
                                            | currency
                                              : "$"
                                              : "symbol"
                                              : "1.0-0")
                                          : "-"
                                      }}
                                    </span>
                                  </div>
                                </div>
                                <hr />
                                <!-- <div class="row mt-2">
                                  <div class="col text-sub-total">
                                    <Span class="ml-4 pl-3">Total Cost</Span>
                                  </div>
                                  <div
                                    *ngFor="
                                      let item of universityList;
                                      let index = index
                                    "
                                    class="col text-right"
                                  >
                                    <span
                                      *ngIf="showOcrData[index]"
                                      class="text-sub-total"
                                      [style.color]="getColor(item.color)"
                                    >
                                      {{
                                        item.hasOwnProperty("ocrDataCoaItems")
                                          ? (item.ocrDataCoaSum
                                            | currency
                                              : "$
                                      "
                                              : "symbol"
                                              : "1.0-0")
                                          : "-"
                                      }}
                                    </span>
                                  </div>
                                </div> -->
                              </accordion-group>
                            </accordion>
                          </div>
                        </accordion-group>
                      </accordion>
                    </div>
                    <div class="card mb-2 border-bottom pb-2">
                      <accordion>
                        <accordion-group #myGroup7>
                          <button
                            class="btn btn-link btn-block clearfix"
                            accordion-heading
                            type="button"
                          >
                            <div class="card-header">
                              <div class="row">
                                <div class="col text-left">
                                  <h4 class="m-zero">
                                    <i
                                      *ngIf="!myGroup7?.isOpen"
                                      class="fa fa-plus mr-2"
                                    ></i>
                                    <i
                                      *ngIf="myGroup7?.isOpen"
                                      class="fa fa-minus mr-2"
                                    ></i>
                                    Total Scholarships & Aid
                                  </h4>
                                </div>
                                <div
                                  class="col text-right"
                                  *ngFor="
                                    let item of universityList;
                                    let index = index
                                  "
                                >
                                  <span *ngIf="!showOcrData[index]">
                                    <!-- {{
                                      item.dropDownData["result"]?.totalGrant?.amount != "" &&
                                      item?.dropDownData["result"]?.totalGrant
                                        ?.amount != undefined &&
                                      item?.dropDownData["result"]?.totalGrant
                                        ?.amount > 0
                                        ? (roundOfNumber(
                                            getMeritHeaderAmount1(
                                              item.dropDownData["result"]
                                                .totalGrant.amount,
                                              index
                                            )
                                          )
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : "-"
                                    }} -->

                                    <!-- {{
                                      getMeritHeaderAmount1(
                                        item.dropDownData["result"].totalGrant
                                          ?.amount,
                                        index
                                      )
                                        ? (getMeritHeaderAmount1(
                                            item.dropDownData["result"]
                                              .totalGrant.amount,
                                            index
                                          )
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : "-"
                                    }} -->
                                    {{
                                      item?.dropDownData?.totalGrant
                                        ? (item?.dropDownData?.totalGrant
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : "-"
                                    }}
                                    <!-- <ng-container
                                      *ngIf="
                                        checkOutStateGridData(item, index) ==
                                        true
                                      "
                                    >
                                      <span>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke-width="1.5"
                                          stroke="currentColor"
                                          class="w-6 h-6"
                                          style="
                                            display: inline-block;
                                            width: 17px;
                                            color: rgb(52, 170, 52);
                                          "
                                        >
                                          <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                                          />
                                        </svg>
                                      </span>
                                 
                                    </ng-container> -->
                                    <!-- <ng-container *ngIf="checkOutStateGridData(item, index) ==true">
                                      <span
                                        class="t-demo__btn unique_span"
                                        ngxTippy
                                        [ngxTippy]="htmlTemplate"
                                        [tippyName]="'outStateGridNotUsed_Merit' + index"
                                        [tippyProps]="templateRef"
                                        class="text-success ml-1 labeltoolTip-hover"
                                      >
                                      <svg
                                      
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      class="w-6 h-6"
                                      style="display: inline-block; width: 17px; color: rgb(52, 170, 52)"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                                      /></svg>
                                      </span>
                                      <template #htmlTemplate>
                                        <div class="t-template" #tippyTemplatePassElement>
                                          <p class="t-template__info text-left">
                                           The grants for this college are calculated using  grant data for in-state students, actual grants may vary.

                                          </p>
                                        </div>
                                      </template>
                                    </ng-container> -->
                                    <!-- {{
                           
                                      getMeritHeaderAmount1(
                                        item.dropDownData["result"].totalGrant
                                          ?.amount,
                                        index
                                      )
                                        ? (roundOfNumber(
                                            getMeritHeaderAmount1(
                                              item.dropDownData["result"]
                                                .totalGrant.amount,
                                              index
                                            )
                                          )
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : "-"
                                    }} -->
                                  </span>
                                  <span *ngIf="showOcrData[index]">
                                    <!-- {{
                                      item.ocrDataScholarshipsSumEdited
                                        ? (roundOfNumber(
                                            item.ocrDataScholarshipsSumEdited
                                          )
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : item.ocrDataScholarshipsSum !=
                                            undefined &&
                                          item.ocrDataScholarshipsSum > 0
                                        ? (roundOfNumber(
                                            item.ocrDataScholarshipsSum
                                          )
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : "-"
                                    }} -->

                                    {{
                                      item.ocrDataScholarshipsSumEdited
                                        ? (item.ocrDataScholarshipsSumEdited
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : item.ocrDataScholarshipsSum !=
                                            undefined &&
                                          item.ocrDataScholarshipsSum > 0
                                        ? (item.ocrDataScholarshipsSum
                                          | currency
                                            : "$ "
                                            : "symbol"
                                            : "1.0-0")
                                        : "-"
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </button>

                          <div
                            class="card-body gift-d pt-0 border-bottom pb-3"
                            *ngIf="showBreakdown"
                          >
                            <accordion [isAnimated]="true">
                              <!-- [closeOthers]="true" -->
                              <accordion-group
                                class="mb-1"
                                [isOpen]="false"
                                #myGroup4
                              >
                                <button
                                  class="btn btn-link btn-block clearfix"
                                  accordion-heading
                                  type="button"
                                >
                                  <div class="row">
                                    <div class="col text-left">
                                      <div class="ml-3">
                                        <span
                                          [ngClass]="{
                                            'mr-1 minusico': myGroup4?.isOpen,
                                            'mr-1 plusico': !myGroup4?.isOpen
                                          }"
                                        >
                                        </span
                                        >&nbsp;Inst. Grants
                                        <!-- <span class="info" (click)="openInfoMeritRange()"> 
                                          
                                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 " style="display: inline-block; width:17px; color:rgb(52, 170, 52)">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg></span> -->
                                      </div>
                                    </div>
                                    <div
                                      class="col text-right"
                                      *ngFor="
                                        let item of universityList;
                                        let index = index
                                      "
                                    >
                                      <span
                                        *ngIf="!showOcrData[index]"
                                        class="ins"
                                      >
                                        {{
                                          item?.dropDownData["result"]
                                            ?.institutionalGrants
                                            ?.totalInstitutionalGrant?.amount !=
                                            "" &&
                                          item?.dropDownData["result"]
                                            ?.institutionalGrants
                                            ?.totalInstitutionalGrant?.amount !=
                                            undefined &&
                                          item?.dropDownData["result"]
                                            ?.institutionalGrants
                                            ?.totalInstitutionalGrant?.amount >
                                            0
                                            ? (getMeritHeaderAmount(
                                                item.dropDownData["result"]
                                                  .institutionalGrants
                                                  .totalInstitutionalGrant
                                                  .amount,
                                                index
                                              )
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : "-"
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </button>
                                <app-accordion
                                  [type]="'meritScholerShip'"
                                  [meritScholerShipData]="meritScholerShipData"
                                ></app-accordion>
                                <div class="row mt-1 mb-2 pb-1 pt-1">
                                  <div class="col">
                                    <span class="ml-4 pl-3"
                                      >Affinity Grant</span
                                    >
                                  </div>
                                  <ng-container
                                    *ngFor="
                                      let item of universityList;
                                      let index = index
                                    "
                                  >
                                    <ng-container
                                      *ngIf="showOcrData[index] == true"
                                    >
                                      <div class="col text-right">
                                        <span>
                                          {{ "-" }}
                                        </span>
                                      </div>
                                    </ng-container>
                                    <ng-container
                                      *ngIf="showOcrData[index] == false"
                                    >
                                      <ng-container
                                        *ngIf="
                                          getAffinityAmount(
                                            item?.dropDownData
                                              ?.yearWiseAffinityQuestion
                                          )
                                        "
                                      >
                                        <div
                                          class="col text-right affinity-amt"
                                        >
                                          <span
                                            (click)="openToolTipPopup(index)"
                                          >
                                            {{
                                              getAffinityAmount(
                                                item?.dropDownData
                                                  ?.yearWiseAffinityQuestion
                                              ) != 0
                                                ? (getAffinityAmount(
                                                    item?.dropDownData
                                                      ?.yearWiseAffinityQuestion
                                                  )
                                                  | currency
                                                    : "$"
                                                    : "symbol"
                                                    : "1.0-0")
                                                : "-"
                                            }}
                                          </span>
                                        </div>
                                      </ng-container>

                                      <ng-container
                                        *ngIf="
                                          getAffinityAmount(
                                            item?.dropDownData
                                              ?.yearWiseAffinityQuestion
                                          ) == 0
                                        "
                                      >
                                        <div class="col text-right">
                                          <span>
                                            {{ "-" }}
                                          </span>
                                        </div>
                                      </ng-container>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </accordion-group>
                              <accordion-group
                                *ngIf="federalAidData.length > 0"
                                class="mb-1"
                                [isOpen]="false"
                                #myGroup2
                              >
                                <button
                                  class="btn btn-link btn-block clearfix"
                                  accordion-heading
                                  type="button"
                                >
                                  <div class="row">
                                    <div class="col text-left">
                                      <div class="ml-3">
                                        <span
                                          [ngClass]="{
                                            'mr-1 minusico': myGroup2?.isOpen,
                                            'mr-1 plusico': !myGroup2?.isOpen
                                          }"
                                        ></span
                                        >&nbsp;Federal Aid
                                      </div>
                                    </div>
                                    <div
                                      class="col text-right"
                                      *ngFor="
                                        let item of universityList;
                                        let index = index
                                      "
                                    >
                                      <span *ngIf="!showOcrData[index]">
                                        {{
                                          nan(gettotalFederalAid(index))
                                            ? gettotalFederalAid(index)
                                            : gettotalFederalAid(index)
                                            ? (gettotalFederalAid(index)
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : "-"
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </button>

                                <app-accordion
                                  [type]="'federalAid'"
                                  [federalAidData]="federalAidData"
                                ></app-accordion>
                              </accordion-group>

                              <accordion-group
                                class="mb-1"
                                [isOpen]="false"
                                #myGroup3
                                *ngIf="StateAidData.length > 0"
                              >
                                <button
                                  class="btn btn-link btn-block clearfix"
                                  accordion-heading
                                  type="button"
                                >
                                  <div class="row">
                                    <div class="col text-left">
                                      <span
                                        [ngClass]="{
                                          'mr-1 minusico': myGroup3?.isOpen,
                                          'mr-1 plusico': !myGroup3?.isOpen
                                        }"
                                        class="ml-3"
                                      ></span
                                      >&nbsp;State Aid
                                    </div>

                                    <div
                                      class="col text-right"
                                      *ngFor="
                                        let item of universityList;
                                        let index = index
                                      "
                                    >
                                      <span *ngIf="!showOcrData[index]">
                                        {{
                                          nan(gettotalStateAid(index))
                                            ? gettotalStateAid(index)
                                            : gettotalStateAid(index)
                                            ? (gettotalStateAid(index)
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : "-"
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </button>

                                <app-accordion
                                  [type]="'stateGrant'"
                                  [StateAidData]="StateAidData"
                                ></app-accordion>
                              </accordion-group>

                              <accordion-group
                                *ngIf="
                                  this.showOcrScholarshipsDataBucket.includes(
                                    true
                                  ) && this.showOcrData.includes(true)
                                "
                                class="mb-1"
                                [isOpen]="false"
                                #myGroup1
                              >
                                <button
                                  class="btn btn-link btn-block clearfix"
                                  accordion-heading
                                  type="button"
                                >
                                  <div class="row">
                                    <div class="col text-left">
                                      <span
                                        [ngClass]="{
                                          'mr-1 minusico': myGroup1?.isOpen,
                                          'mr-1 plusico': !myGroup1?.isOpen
                                        }"
                                        class="ml-3"
                                      ></span
                                      ><span></span>&nbsp;Award Letter Grants
                                      <i class="fa fa-sticky-note-o"></i>
                                    </div>
                                    <!-- <div
                                      class="col text-right"
                                      *ngFor="let item of universityList"
                                    >
                                      <span *ngIf="item.institutionAidAmountSum>0;else elseSpan">
                                        
                                        {{ item.institutionAidAmountSum | currency: '$':'symbol':'1.0-0'}}

                                      </span><ng-template #elseSpan>$ 0</ng-template>
                                    </div> -->

                                    <div
                                      *ngFor="
                                        let item of universityList;
                                        let index = index
                                      "
                                      class="col text-right"
                                    >
                                      <!-- <span *ngIf="!showOcrData[index]" [style.color]="getColor(item.color)">-</span> -->
                                      <span
                                        *ngIf="showOcrData[index]"
                                        class="text-sub-total"
                                        [style.color]="getColor(item.color)"
                                      >
                                        <!-- {{
                                          item.ocrDataScholarshipsSum | currency : "$ ": "symbol": "1.0-0"
                                        }} -->
                                        <!-- {{
                                          item.hasOwnProperty(
                                            "ocrDataScholarshipsSumEdited"
                                          ) && item.ocrDataScholarshipsSumEdited
                                            ? "-" -->

                                        {{
                                          item.ocrDataScholarshipsSumEdited
                                            ? (item.ocrDataScholarshipsSumEdited
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : item.hasOwnProperty(
                                                "ocrDataScholarshipsSum"
                                              ) && item?.ocrDataScholarshipsSum
                                            ? (item.ocrDataScholarshipsSum
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : "-"
                                        }}

                                        <!-- {{
                                          item.ocrDataScholarshipsSumEdited
                                            ? (roundOfNumber(
                                                item.ocrDataScholarshipsSumEdited
                                              )
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : item.hasOwnProperty(
                                                "ocrDataScholarshipsSum"
                                              ) && item?.ocrDataScholarshipsSum
                                            ? (roundOfNumber(
                                                item.ocrDataScholarshipsSum
                                              )
                                              | currency
                                                : "$ "
                                                : "symbol"
                                                : "1.0-0")
                                            : "-"
                                        }} -->

                                        <!-- {{item.ocrDataScholarshipsSum  }} -->
                                      </span>
                                    </div>
                                  </div>
                                </button>
                                <div
                                  class="row mt-2"
                                  *ngFor="let key of ocrScholarshipsDataList"
                                >
                                  <div class="col">
                                    <span class="ml-4 pl-3">{{
                                      key.label
                                    }}</span>
                                  </div>
                                  <div
                                    *ngFor="
                                      let item of universityList;
                                      let index = index
                                    "
                                    class="col text-right"
                                  >
                                    <span
                                      *ngIf="showOcrData[index]"
                                      [style.color]="getColor(item.color)"
                                    >
                                      {{
                                        item.hasOwnProperty(
                                          "ocrDataScholarshipsSumEdited"
                                        ) && item.ocrDataScholarshipsSumEdited
                                          ? "-"
                                          : item.hasOwnProperty(
                                              "ocrDataScholarshipItems"
                                            ) &&
                                            item.ocrDataScholarshipItems.hasOwnProperty(
                                              key.value
                                            ) &&
                                            item.ocrDataScholarshipItems[
                                              key.value
                                            ] != " "
                                          ? (item.ocrDataScholarshipItems[
                                              key.value
                                            ]
                                            | currency
                                              : "$ "
                                              : "symbol"
                                              : "1.0-0")
                                          : "-"
                                      }}
                                    </span>
                                  </div>
                                </div>

                                <!-- <div class="row mt-2">
                                  <div class="col text-sub-total">
                                    <span class="ml-3 ml-4 pl-3"
                                      >Total Scholarship</span
                                    >
                                  </div>
                                  <div
                                    *ngFor="
                                      let item of universityList;
                                      let index = index
                                    "
                                    class="col text-right"
                                  >
                                    <span *ngIf="!showOcrData[index]" [style.color]="getColor(item.color)">-</span>  //commentd
                                    <span
                                      *ngIf="showOcrData[index]"
                                      class="text-sub-total"
                                      [style.color]="getColor(item.color)"
                                    >
                                      {{
                                        item.ocrDataScholarshipsSum
                                          | currency
                                            : "$
                                      "
                                            : "symbol"
                                            : "1.0-0"
                                      }}
                                      {{item.ocrDataScholarshipsSum  }}  //commented
                                    </span>
                                  </div>
                                </div> -->
                              </accordion-group>
                            </accordion>
                            <!-- <div class="row mt-3">
                              <div class="col-md-12 note">
                                <span
                                  style="
                                    font-size: 11px;
                                    color: rgb(80, 80, 80) !important;
                                    font-style: normal;
                                    font-weight: 500;
                                  "
                                >
                                  *All amounts are rounded up to the nearest
                                  100.<br />
                              // not use this line   *Merit scholarship & gift aid based on 2021 IPEDS data<br />
                                  *Estimated grants and scholarships may not
                                  equal to the sum of all listed awards due to
                                  overlaps or other institutional eligibility
                                  rules.<br />
                                  *Based on the students state they will be
                                  eligible for state grants.
                                </span>
                              </div>
                            </div> -->
                          </div>
                          <div
                            class="card-body error-text pt-0"
                            *ngIf="!showBreakdown"
                          >
                            User session is expired or not available We are
                            unable to process your request. Please try later.
                          </div>
                        </accordion-group>
                      </accordion>
                    </div>
                    <!-- <div class="card mb-3 mt-3 border-bottom pb-3">
                      <div class="card-header">
                        <div class="row">
                          <div class="col">
                            <h4 class="m-zero coa">
                              Approx Out of Pocket Cost
                              Student's approximate Out of Pocket Cost
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div> -->

                    <div class="card mb-2 mt-2 border-bottom pb-2">
                      <!-- <accordion>
                        <accordion-group #myGroup99>
                          <button
                            class="btn btn-link btn-block clearfix"
                            accordion-heading
                            type="button"
                          > -->
                      <div class="card-header">
                        <div class="row">
                          <div class="col text-left">
                            <h4 class="m-zero coa">
                              <!-- <i
                                      *ngIf="!myGroup99?.isOpen"
                                      class="fa fa-plus mr-2"
                                    ></i>
                                    <i
                                      *ngIf="myGroup99?.isOpen"
                                      class="fa fa-minus mr-2"
                                    ></i> -->
                              Approx Out of Pocket Cost
                              <br />
                              <p class="approx_pocket_sub_p">
                                (excludes Outside Scholarships)
                              </p>
                            </h4>
                          </div>

                          <div
                            *ngFor="
                              let item of universityList;
                              let index = index
                            "
                            class="col text-right"
                          >
                            <span *ngIf="!showOcrData[index]">
                              <!-- {{
                                getOutOfPocketAmount(item, index) > 0
                                  ? (getOutOfPocketAmount(item, index)
                                    | currency : "$ " : "symbol" : "1.0-0")
                                  : "-"
                              }} -->
                              {{
                                item?.dropDownData?.outOfPocketCost > 0
                                  ? (item?.dropDownData?.outOfPocketCost
                                    | currency : "$ " : "symbol" : "1.0-0")
                                  : "-"
                              }}
                            </span>
                            <span *ngIf="showOcrData[index]">
                              {{
                                item.ocrDataOutOfPocketEdited
                                  ? (item.ocrDataOutOfPocketEdited
                                    | currency : "$ " : "symbol" : "1.0-0")
                                  : getbasedOnAwardLetterAmount(item)
                                  ? (roundOfNumber(
                                      getbasedOnAwardLetterAmount(item)
                                    ) | currency : "$ " : "symbol" : "1.0-0")
                                  : "-"
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- </button> -->

                      <!-- <div
                            class="container-fluid pr-0 pl-0 border-bottom pb-3"
                          > -->

                      <!-- <div class="row mt-1 pt-1" style="color: #193d7c">
                              <div class="col col-first-0">
                                <span class="ml-4 Based-On-College">
                                 
                                  Approx Out Of Pocket Cost
                                  <br />
                                  <p class="approx_pocket_sub_p">
                                    (excludes Outside Scholarships)
                                  </p>
                                </span>
                              </div>

                              <div
                                *ngFor="
                                  let item of universityList;
                                  let index = index
                                "
                                class="col text-right"
                              >
                                <span
                                  class="Based-On-College"
                                  *ngIf="!isShowIpedsData[index] && !showOcrData[index]">
                                  {{
                                    getbasedOnCollegeWebsiteAmount(item)
                                      ? (getbasedOnCollegeWebsiteAmount(item)
                                        | currency : "$ " : "symbol" : "1.0-0")
                                      : "-"
                                  }}
                                </span>

                                <span *ngIf="isShowIpedsData[index] && !showOcrData[index]">
                                  {{
                                    getOutOfPocketAmount(index) > 0
                                      ? (getOutOfPocketAmount(index)
                                        | currency : "$ " : "symbol" : "1.0-0")
                                      : "-"
                                  }}
                                </span>
                                <span
                                class="Based-On-College"
                                *ngIf="showOcrData[index] && !isShowIpedsData[index]"
                              >
                                {{
                                  item.ocrDataOutOfPocketEdited
                                    ? (item.ocrDataOutOfPocketEdited
                                      | currency : "$ " : "symbol" : "1.0-0")
                                    : getbasedOnAwardLetterAmount(item)
                                    ? (roundOfNumber(
                                        getbasedOnAwardLetterAmount(item)
                                      )
                                      | currency : "$ " : "symbol" : "1.0-0")
                                    : "-"
                                }}

                              </span>

                              </div>
                            </div> -->

                      <!-- <div
                              *ngIf="
                                this.showOcrCoaDataBucket.includes(true) &&
                                this.showOcrData.includes(true)
                              "
                              class="row mt-1 pt-1"
                              style="color: #f26722"
                            >
                              <div class="col col-first-0">
                                <span class="ml-4 Based-On-College"
                                  >Based on Award Letter
                                  <i class="fa fa-sticky-note-o"></i>
                                  <br />

                                  <p class="approx_pocket_sub_p">
                                    (includes Outside Scholarships)
                                  </p>
                                </span>
                              </div>

                              <div
                                *ngFor="
                                  let item of universityList;
                                  let ind = index
                                "
                                class="col text-right"
                              >
                                <span
                                  class="Based-On-College"
                                  *ngIf="showOcrData[ind]"
                                >
                                  {{
                                    item.ocrDataOutOfPocketEdited
                                      ? (item.ocrDataOutOfPocketEdited
                                        | currency : "$ " : "symbol" : "1.0-0")
                                      : getbasedOnAwardLetterAmount(item)
                                      ? (roundOfNumber(
                                          getbasedOnAwardLetterAmount(item)
                                        )
                                        | currency : "$ " : "symbol" : "1.0-0")
                                      : "-"
                                  }}

                                </span>
                              </div>
                            </div> -->
                      <!-- </div> -->
                      <!-- </accordion-group>
                      </accordion> -->
                    </div>
                    <div class="card mb-3 mt-2 border-bottom pb-2">
                      <accordion>
                        <accordion-group #myGroup8>
                          <button
                            class="btn btn-link btn-block clearfix"
                            accordion-heading
                            type="button"
                          >
                            <div class="card-header">
                              <div class="row">
                                <div class="col text-left">
                                  <h4 class="m-zero coa">
                                    <i
                                      *ngIf="!myGroup8?.isOpen"
                                      class="fa fa-plus mr-2"
                                    ></i>
                                    <i
                                      *ngIf="myGroup8?.isOpen"
                                      class="fa fa-minus mr-2"
                                    ></i>
                                    Comparison Metrics of College<a
                                      (click)="resultnote()"
                                      ><sup>2</sup></a
                                    >
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </button>

                          <app-accordion
                            [type]="'Comparision'"
                            [ComparisionMatrixList]="ComparisionMatrixList"
                          ></app-accordion>

                          <!-- <div class="col-md-12 note">
                            <span
                              style="
                                font-size: 11px;
                                color: rgb(80, 80, 80) !important;
                                font-style: normal;
                                font-weight: 500;
                              "
                            >
                              Source: Georgetown University Center on Education
                              and the Workforce
                            </span>
                          </div> -->
                        </accordion-group>
                      </accordion>
                    </div>
                    <div
                      class="card mb-23 border-bottom pb-2"
                      *ngIf="isShowCollegeWiseProgramList"
                    >
                      <accordion>
                        <accordion-group #myGroup75>
                          <button
                            class="btn btn-link btn-block clearfix"
                            accordion-heading
                            type="button"
                          >
                            <div class="card-header">
                              <div class="row">
                                <div class="col text-left">
                                  <h4 class="m-zero coa">
                                    <i
                                      *ngIf="!myGroup75?.isOpen"
                                      class="fa fa-plus mr-2"
                                    ></i>
                                    <i
                                      *ngIf="myGroup75?.isOpen"
                                      class="fa fa-minus mr-2"
                                    ></i>
                                    <!-- ROI for Desired Field of Study ({{programName}}) -->
                                    ROI for Desired Field of Study
                                    <span> ({{ programName }})</span
                                    ><sup><a (click)="resultnote()">3</a></sup>
                                    <!-- ROI for Program -->
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </button>
                          <!-- <div class="fm-row ml-2 col-5 mt-2">
                            <select
                            id="prgramStudy"
                            [(ngModel)]="desiredStudeyModelValue"
                            (ngModelChange)="
                              changeProgram(desiredStudeyModelValue, $event)
                            "
                          >
                            <option
                              *ngFor="let opt of desiredStudeyDDL"
                              [value]="opt.value"
                            >
                              {{ opt.label }}
                            </option>
                          </select> </div> -->

                          <app-accordion
                            [type]="'collegeWiseProgram'"
                            [collegeWiseProgramList]="collegeWiseProgramList"
                          ></app-accordion>
                        </accordion-group>
                      </accordion>
                    </div>

                    <div
                      class="card mb-2 border-bottom pb-2"
                      *ngIf="isShowCollegeWiseAgeOfEarningList"
                    >
                      <app-chart
                        [type]="'AgeWiseEarning'"
                        [title]="'Age wise Estimated Annual Earnings'"
                        [collegeWiseAgeOfEarning]="collegeWiseAgeOfEarningList"
                      ></app-chart>
                    </div>

                    <div class="note-bg">
                      <!-- <a href="#" onclick="openPopup()">Open Popup</a> -->
                      <p class="important-note">
                        <a (click)="resultnote()" class="cursor-pointer"
                          >Notes & Disclaimer</a
                        >
                      </p>
                    </div>
                    <!-- <div class="card mb-3" *ngIf="isShowcollegeWise4YearTotalExpensesLifeTimeList">
                  
                    <app-chart [type]="'4YearExpensesTimeLine'" [title]="'Lifetime ROI and Total 4 years Expenditure Comparison'"
                          [college4YearExpense]="collegeWise4YearTotalExpensesLifeTimeList"></app-chart>
                  </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
        <div class="col-md-12">
          <div class="row mt-5 mb-3"></div>
        </div>
      </div> -->

        <!-- <div class="row" *ngIf="!loading">
          <div *ngIf="!isLogin" class="col-md-12 error-text">
            User session is expired or not available We are unable to process your
            request. Please try later.
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="align-page-bottom mt-3">
    <div
      class="justify-content-center text-center border-top pt-4 d-flex flex-row"
    >
      <button class="page-btn mx-2" (click)="previous()">Previous</button>

      <button
        class="page-btn mx-2"
        *ngIf="isMailMe"
        (click)="sendMail('mailMe')"
      >
        Mail me
      </button>
    </div>
  </div>

  <script>
    window.onscroll = function () {
      myFunction();
    };

    var navbar = document.getElementById("navbar");
    var sticky = navbar.offsetTop;

    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky");
      } else {
        navbar.classList.remove("sticky");
      }
    }
  </script>
</div>
